var map = {
	"./AddPos/modules/AddPosReducers": [
		"./src/routes/AddPos/modules/AddPosReducers.js",
		"AddPos-modules-AddPosReducers"
	],
	"./Amex/modules/AmexReducers": [
		"./src/routes/Amex/modules/AmexReducers.js",
		"Amex-modules-AmexReducers"
	],
	"./AmexHotel/modules/AmexHotelReducers": [
		"./src/routes/AmexHotel/modules/AmexHotelReducers.js",
		"AmexHotel-modules-AmexHotelReducers"
	],
	"./Aml/modules/AmlReducers": [
		"./src/routes/Aml/modules/AmlReducers.js",
		"Aml-modules-AmlReducers"
	],
	"./ApiCloudSmartPos/modules/ApiCloudSmartPosReducers": [
		"./src/routes/ApiCloudSmartPos/modules/ApiCloudSmartPosReducers.js",
		"ApiCloudSmartPos-modules-ApiCloudSmartPosReducers"
	],
	"./BackupPos/modules/BackupPosReducers": [
		"./src/routes/BackupPos/modules/BackupPosReducers.js",
		"BackupPos-modules-BackupPosReducers"
	],
	"./BuoniPasto/modules/BuoniPastoReducers": [
		"./src/routes/BuoniPasto/modules/BuoniPastoReducers.js",
		"BuoniPasto-modules-BuoniPastoReducers"
	],
	"./CallUs/modules/CallUsReducers": [
		"./src/routes/CallUs/modules/CallUsReducers.js",
		"CallUs-modules-CallUsReducers"
	],
	"./ChangePos/modules/ChangePosReducers": [
		"./src/routes/ChangePos/modules/ChangePosReducers.js",
		"ChangePos-modules-ChangePosReducers"
	],
	"./CompanyData/modules/CompanyDataReducers": [
		"./src/routes/CompanyData/modules/CompanyDataReducers.js",
		"CompanyData-modules-CompanyDataReducers"
	],
	"./Comunications/modules/ComunicationsReducers": [
		"./src/routes/Comunications/modules/ComunicationsReducers.js",
		"Comunications-modules-ComunicationsReducers"
	],
	"./ContactUs/modules/ContactUsReducers": [
		"./src/routes/ContactUs/modules/ContactUsReducers.js",
		"ContactUs-modules-ContactUsReducers"
	],
	"./Costs/modules/CostsReducers": [
		"./src/routes/Costs/modules/CostsReducers.js",
		"Costs-modules-CostsReducers"
	],
	"./Dcc/modules/DccReducers": [
		"./src/routes/Dcc/modules/DccReducers.js",
		"Dcc-modules-DccReducers"
	],
	"./DeactivateTerminal/modules/DeactivateTerminalReducers": [
		"./src/routes/DeactivateTerminal/modules/DeactivateTerminalReducers.js",
		"DeactivateTerminal-modules-DeactivateTerminalReducers"
	],
	"./Dispute/modules/DisputeReducers": [
		"./src/routes/Dispute/modules/DisputeReducers.js",
		"Dispute-modules-DisputeReducers"
	],
	"./DisputeUci/modules/DisputeUciReducers": [
		"./src/routes/DisputeUci/modules/DisputeUciReducers.js",
		"DisputeUci-modules-DisputeUciReducers"
	],
	"./Documents/modules/DocumentsReducers": [
		"./src/routes/Documents/modules/DocumentsReducers.js",
		"Documents-modules-DocumentsReducers"
	],
	"./HeyLight/modules/HeyLightReducers": [
		"./src/routes/HeyLight/modules/HeyLightReducers.js",
		"HeyLight-modules-HeyLightReducers"
	],
	"./Homepage/modules/HomepageReducers": [
		"./src/routes/Homepage/modules/HomepageReducers.js",
		"Homepage-modules-HomepageReducers"
	],
	"./Impersonification/modules/ImpersonificationReducers": [
		"./src/routes/Impersonification/modules/ImpersonificationReducers.js",
		"Impersonification-modules-ImpersonificationReducers"
	],
	"./KitStart/modules/KitStartReducers": [
		"./src/routes/KitStart/modules/KitStartReducers.js",
		"KitStart-modules-KitStartReducers"
	],
	"./LoginApp/modules/LoginAppReducers": [
		"./src/routes/LoginApp/modules/LoginAppReducers.js",
		"LoginApp-modules-LoginAppReducers"
	],
	"./LoginHandler/modules/LoginHandlerReducers": [
		"./src/routes/LoginHandler/modules/LoginHandlerReducers.js",
		"LoginHandler-modules-LoginHandlerReducers"
	],
	"./Menu/modules/MenuReducers": [
		"./src/routes/Menu/modules/MenuReducers.js",
		"Menu-modules-MenuReducers"
	],
	"./Micropagamenti/modules/MicropagamentiReducers": [
		"./src/routes/Micropagamenti/modules/MicropagamentiReducers.js",
		"Micropagamenti-modules-MicropagamentiReducers"
	],
	"./MobileSso/modules/MobileSsoReducers": [
		"./src/routes/MobileSso/modules/MobileSsoReducers.js",
		"MobileSso-modules-MobileSsoReducers"
	],
	"./MosSsoMobile/modules/MosSsoMobileReducers": [
		"./src/routes/MosSsoMobile/modules/MosSsoMobileReducers.js",
		"MosSsoMobile-modules-MosSsoMobileReducers"
	],
	"./NexiClub/modules/NexiClubReducers": [
		"./src/routes/NexiClub/modules/NexiClubReducers.js",
		"NexiClub-modules-NexiClubReducers"
	],
	"./NexiExclusive/modules/NexiExclusiveReducers": [
		"./src/routes/NexiExclusive/modules/NexiExclusiveReducers.js",
		"NexiExclusive-modules-NexiExclusiveReducers"
	],
	"./PagoPa/modules/PagoPaReducers": [
		"./src/routes/PagoPa/modules/PagoPaReducers.js",
		"PagoPa-modules-PagoPaReducers"
	],
	"./PayByLink/modules/PayByLinkReducers": [
		"./src/routes/PayByLink/modules/PayByLinkReducers.js",
		"PayByLink-modules-PayByLinkReducers"
	],
	"./PayByLinkService/modules/PayByLinkServiceReducers": [
		"./src/routes/PayByLinkService/modules/PayByLinkServiceReducers.js",
		"PayByLinkService-modules-PayByLinkServiceReducers"
	],
	"./Pci/modules/PciReducers": [
		"./src/routes/Pci/modules/PciReducers.js",
		"Pci-modules-PciReducers"
	],
	"./PersonalData/modules/PersonalDataReducers": [
		"./src/routes/PersonalData/modules/PersonalDataReducers.js",
		"PersonalData-modules-PersonalDataReducers"
	],
	"./Profile/modules/ProfileReducers": [
		"./src/routes/Profile/modules/ProfileReducers.js",
		"Profile-modules-ProfileReducers"
	],
	"./ProfileMenu/modules/ProfileMenuReducers": [
		"./src/routes/ProfileMenu/modules/ProfileMenuReducers.js",
		"ProfileMenu-modules-ProfileMenuReducers"
	],
	"./RecoveryPassword/modules/RecoveryPasswordReducers": [
		"./src/routes/RecoveryPassword/modules/RecoveryPasswordReducers.js",
		"RecoveryPassword-modules-RecoveryPasswordReducers"
	],
	"./Registration/modules/RegistrationReducers": [
		"./src/routes/Registration/modules/RegistrationReducers.js",
		"src_routes_Registration_modules_RegistrationActions_js-src_routes_Registration_modules_flowMe-e4c5a8",
		"Registration-modules-RegistrationReducers"
	],
	"./RegistrationNb/modules/RegistrationNbReducers": [
		"./src/routes/RegistrationNb/modules/RegistrationNbReducers.js",
		"RegistrationNb-modules-RegistrationNbReducers"
	],
	"./Report/modules/ReportReducers": [
		"./src/routes/Report/modules/ReportReducers.js",
		"Report-modules-ReportReducers"
	],
	"./Results/modules/ResultsReducers": [
		"./src/routes/Results/modules/ResultsReducers.js",
		"Results-modules-ResultsReducers"
	],
	"./RubiconeGold/modules/RubiconeGoldReducers": [
		"./src/routes/RubiconeGold/modules/RubiconeGoldReducers.js",
		"RubiconeGold-modules-RubiconeGoldReducers"
	],
	"./SecondaryUsers/modules/SecondaryUsersReducers": [
		"./src/routes/SecondaryUsers/modules/SecondaryUsersReducers.js",
		"src_routes_SecondaryUsers_modules_SecondaryUsersActions_js-src_routes_SecondaryUsers_modules_-a6a046",
		"SecondaryUsers-modules-SecondaryUsersReducers"
	],
	"./Services/modules/ServicesReducers": [
		"./src/routes/Services/modules/ServicesReducers.js",
		"Services-modules-ServicesReducers"
	],
	"./ShortLink/modules/ShortLinkReducers": [
		"./src/routes/ShortLink/modules/ShortLinkReducers.js",
		"ShortLink-modules-ShortLinkReducers"
	],
	"./SoftPos/modules/SoftPosReducers": [
		"./src/routes/SoftPos/modules/SoftPosReducers.js",
		"SoftPos-modules-SoftPosReducers"
	],
	"./Support/modules/SupportReducers": [
		"./src/routes/Support/modules/SupportReducers.js",
		"Support-modules-SupportReducers"
	],
	"./SupportPreLogin/modules/SupportPreLoginReducers": [
		"./src/routes/SupportPreLogin/modules/SupportPreLoginReducers.js",
		"SupportPreLogin-modules-SupportPreLoginReducers"
	],
	"./Transactions/modules/TransactionsReducers": [
		"./src/routes/Transactions/modules/TransactionsReducers.js",
		"src_routes_Transactions_modules_TransactionsReducers_js",
		"Transactions-modules-TransactionsReducers"
	],
	"./VetrinaDigitale/modules/VetrinaDigitaleReducers": [
		"./src/routes/VetrinaDigitale/modules/VetrinaDigitaleReducers.js",
		"VetrinaDigitale-modules-VetrinaDigitaleReducers"
	],
	"./Wcf/modules/WcfReducers": [
		"./src/routes/Wcf/modules/WcfReducers.js",
		"Wcf-modules-WcfReducers"
	],
	"./Xpay/modules/XpayReducers": [
		"./src/routes/Xpay/modules/XpayReducers.js",
		"Xpay-modules-XpayReducers"
	],
	"./XpayHotel/modules/XpayHotelReducers": [
		"./src/routes/XpayHotel/modules/XpayHotelReducers.js",
		"XpayHotel-modules-XpayHotelReducers"
	],
	"./XpayRistorante/modules/XpayRistoranteReducers": [
		"./src/routes/XpayRistorante/modules/XpayRistoranteReducers.js",
		"XpayRistorante-modules-XpayRistoranteReducers"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/routes lazy recursive ^\\.\\/.*\\/modules\\/.*Reducers$";
module.exports = webpackAsyncContext;